import { Form, Formik } from "formik";
import * as Yup from "yup";
import { axiosWithToast, dispatchWithToast } from "../Utils";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import PropTypes from "prop-types";

export const PMForm = ({ updateFunction = null, createFunction = null, ...props }) => {
  const {
    initialValues,
    requiredFields,
    id,
    content,
    onRefresh,
  } = props;

  const dispatch = useDispatch();

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={Yup.object({
        // reduce requiredFields that has "field" and "message" properties. All objects is required
        ...requiredFields.reduce((acc, field) => {
          acc[field.field] = field.validation;
          return acc;
        }, {}),
      })}
      onSubmit={(values, helpers) => {
        try {
          if (createFunction.type === "axios") {
            axiosWithToast(
              id
                ? updateFunction.function(values)
                : createFunction.function(values),
              onRefresh
            );
          } else {
            dispatchWithToast(
              id
                ? updateFunction.function(values)
                : createFunction.function(values),
              onRefresh
            );
          }

          helpers.setStatus({ success: true });
          helpers.setSubmitting(false);
        } catch (err) {
          toast.error("Something went wrong...");
          console.error(err);
          helpers.setStatus({ success: false });
          helpers.setErrors({ submit: err.message });
          helpers.setSubmitting(false);
        }
      }}
    >
      {(formik) => (
        <Form>
          <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-3 sm:gap-3 justify-between">
            <div className="flex w-full col-span-1 sm:col-span-3 right align-right gap-4">
              {typeof content === "function" ? content(formik) : content}
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

// Set mandatory and optional props
PMForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  id: PropTypes.string,

  // requiredFields is an object of "field", "validation"
  // all fields must be set inside the object
  requiredFields: PropTypes.array.isRequired,
  content: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),

  onRefresh: PropTypes.func.isRequired,
  formFields: PropTypes.array.isRequired,

  // updateFunction has a function field and a type field (dispatch/ axios)
  // both fields must be set inside the object
  updateFunction: PropTypes.object, // { function: function, type: string }
  createFunction: PropTypes.object, // { function: function, type: string }
};
